import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static get targets() {
    return ["select", "selectedOption", "list", "tagTemplate", "selectedOptionTemplate", "submitButton", "button", "selectedOptions", "selectedManyOptions", "selectedManyOptionsValue"]
  }

  static get values() {
    return {
      proposals: { type: Array, default: [] },
      selected: { type: Array, default: [] },
      name: String,
      showAggregate: { type: Boolean, default: true }
    }
  }

  connect() {
    this.draftValues = []

    const self = this
    $(this.selectTarget).selectize({
      create: true,
      openOnFocus: false,
      setFirstOptionActive: true,
      onFocus: function () {
        this.close()
      },
      onType: function (str) {
        if (!str.length) {
          this.close()
          return
        }
        this.open()
      },
      render: {
        option_create: function (data, escape) {
          return '<div class="create">' + escape(data.input) + '</div>'
        },
        item: function () {
          return '<div style="display: none"></div>'
        }
      },
      onChange: function (value) {
        self.draftValues = value
        self.submitButtonTarget.disabled = false
        self.#render()
        this.close()
      },
      onDropdownOpen: function () {
        if (this.getTextboxValue().length === 0) {
          this.close();
        }
      },
    })

    this.#render()
  }

  apply() {
    this.selectedValue = this.draftValues
    this.draftValues = []
    this.submitButtonTarget.disabled = true
    this.#render()
    this.#dispatchFilterEvent()
  }

  clear() {
    this.selectedValue = []
    this.submitButtonTarget.disabled = true
    this.#render()
    this.#dispatchFilterEvent()
  }

  remove(event) {
    const alreadyFilteredBy = this.selectedValue.includes(event.params.option)

    this.draftValues = this.draftValues.filter(value => value !== event.params.option)
    this.selectedValue = this.selectedValue.filter(value => value !== event.params.option)
    $(this.selectTarget).data().selectize.removeItem(event.params.option)

    this.#render()
    if (alreadyFilteredBy) {
      this.#dispatchFilterEvent()
    }
  }

  #dispatchFilterEvent() {
    this.dispatch("filter", { detail: { name: this.nameValue, values: this.selectedValue } })
  }

  #render() {
    this.listTarget.innerHTML = ""

    if (this.hasButtonTarget) {
      this.buttonTarget.dataset.selectedFilters = this.selectedValue.length
    }

    // Render selected values inside the dropdown
    this.selectedValue.forEach(option => {
      this.#renderDropdownItem(option)
    });

    // Render draft values inside the dropdown
    this.draftValues.forEach(option => {
      if (!this.selectedValue.includes(option)) {
        this.#renderDropdownItem(option)
      }
    })

    // Show/hide selected filters outside dropdown
    this.showSelectedFilters()
  }

  #renderDropdownItem(option) {
    const clone = this.tagTemplateTarget.content.cloneNode(true)
    const element = clone.firstElementChild
    element.innerHTML = element.innerHTML.replaceAll("$VALUE", option)
    this.listTarget.append(element)
  }

  showSelectedFilters() {
    if (this.showAggregateValue && this.selectedValue.length > 2) {
      // Too many filters selected, show composite box to remove them all
      if (this.hasSelectedManyOptionsTarget) {
        this.selectedManyOptionsTarget.classList.remove("d-none")
      }

      if (this.hasSelectedManyOptionsValueTarget) {
        this.selectedManyOptionsValueTarget.innerText = this.selectedValue.length
      }

      this.selectedOptionTargets.forEach(selectedOption => {
        selectedOption.classList.add("d-none")
      })
      return
    }

    if (this.hasSelectedManyOptionsTarget) {
      this.selectedManyOptionsTarget.classList.add("d-none")
    }

    this.selectedOptionTargets.forEach(selectedOption => {
      if (this.selectedValue.includes(selectedOption.dataset.value)) {
        selectedOption.classList.remove("d-none")
      } else {
        selectedOption.classList.add("d-none")
      }
    })
  }

}


